// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var AccountingExportV1FilesController = function ($scope, $http, AccountingExportV1Postings) {
    $scope.statusClass = function (status) {
        switch (status) {
            case 'Finished':
                return "label-success";
            case 'InProgress':
                return "label-warning";
            case 'Failed':
                return "label-important";
            default:
                return "";
        }
    };

    $scope.exports = AccountingExportV1Postings.query();
    $scope.download = function (id) {
        $http({
            method: "POST",
            url: "/api/v1/AccountingExportV1Postings/" + id + "/downloadlink",
            params: {},
            data: $scope.parameters,
            headers: {},
            cache: false
        }).then(function (response) {
            var downloadInfo = response.data;
            $scope.downloadFile(downloadInfo.Url);
        });
    };
};
AccountingExportV1FilesController.$inject = ['$scope', '$http', 'AccountingExportV1Postings'];
